import React, { useContext, useMemo } from 'react';
import s from './styles.module.scss';
import { IHolder } from '@/interfaces/holder';
import Avatar from '../TradeKey/components/avatar';
import { formatCurrency } from '@/utils/string';
import { WalletContext } from '@/contexts/wallet-context';
import { useProfiles } from '../provider';

export const HOLDER_PORTFOLIO_MODAL = 'HOLDER_PORTFOLIO_MODAL';

interface props {
  holders: IHolder[];
  playerPoolProfile: any;
}

function findAndSwap(arr: any, item1: any, item2: any) {
  const index1 = arr.indexOf(item1);
  const index2 = arr.indexOf(item2);

  if (index1 !== -1 && index2 !== -1) {
    [arr[index1], arr[index2]] = [arr[index2], arr[index1]];
  } else {
    console.log('One or both items not found in the array.');
  }

  return arr;
}

const HolderPortfolioModal = ({ holders, playerPoolProfile }: props) => {
  if (!holders || holders?.length === 0) {
    return <div className={s.noData}>No data</div>;
  }

  const holderFormat = useMemo(() => {
    const me = holders?.find(
      item =>
        item?.user?.address?.toLocaleLowerCase() ===
        playerPoolProfile?.address?.toLocaleLowerCase()
    );
    return findAndSwap(holders, me, holders[0]);
  }, [holders, playerPoolProfile]);

  return (
    <div className={s.portfolioModal}>
      <div className={s.countHolders}>{holderFormat?.length} holders</div>
      <div className={s.list}>
        {holderFormat?.map((item: IHolder) => <ItemHolder item={item} />)}
      </div>
    </div>
  );
};

const ItemHolder = ({ item }: { item: IHolder }) => {
  return (
    <div className={s.item}>
      <div className={s.user}>
        <Avatar
          className={s.avatar}
          url={item?.user?.twitter_avatar}
          address={item?.user?.address || ''}
          width={32}
          name={item?.user?.twitter_name}
          fontSize={10}
        />
        <div className={s.name}>
          <p>{item?.user?.twitter_name}</p>
          <span>@{item?.user?.twitter_username}</span>
        </div>
      </div>
      <div className={s.value}>
        <span>${formatCurrency(item?.portfolio_value_usdt, 0, 2)}</span>
      </div>
    </div>
  );
};

export default HolderPortfolioModal;
